// import getPatientAnalytics from "@custom/rtk-apis/analytics/getPatientAnalytics";
import getAppoitmentAnalytics from "@custom/rtk-apis/analytics/getAppoitmentAnalytics";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  status:"",
  result:null,
  msg:"",
  loading:false,
  error:""
};

const getAppoitmentAnalyticsSlice = createSlice({
  name: "getAppoitmentAnalyticsSlice",
  initialState,
  reducers: {
    clearAppoitmentAnalytics: state => {
      state.status = '';
      state.result = '';
      state.msg = '';
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAppoitmentAnalytics.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getAppoitmentAnalytics.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.status = "SUCCESS";
        state.result = payload;
        state.msg = "Appoitments analytics fetched successfully.";
      })
      .addCase(getAppoitmentAnalytics.rejected, (state, { payload }) => {
        state.result = payload;
        state.loading = false;
      });
  },
});

export default getAppoitmentAnalyticsSlice.reducer;
export const { clearAppoitmentAnalytics } = getAppoitmentAnalyticsSlice.actions;
